/**
 *
 * @param fn
 * @return {Readonly<{process: ((function(): Promise<*>)|*), clear: clear}>}
 */
export function memoize(fn) {
  let cache = {}

  function clear() {
    cache = {}
  }

  async function process() {
    const args = JSON.stringify(arguments)
    if (args in cache) {
      return cache[args]
    } else {
      let result = fn.apply(null, arguments)
      cache[args] = result
      return result
    }
  }

  return Object.freeze({ clear, process })
}
